const LAND_PARCEL_LAYER_ID = 'land-parcel-layer';
const AREA_TO_BE_REFERENCED_LAYER_ID = 'atbr-layer';
const HIGHLIGHT_LAYER_ID = 'land-parcel-highlight-layer';

export { LAND_PARCEL_LAYER_ID, AREA_TO_BE_REFERENCED_LAYER_ID, HIGHLIGHT_LAYER_ID };
